export const options = [
    {
        label: 'To Do',
        value: 'TODO',
    },
    {
        label: 'In Progress',
        value: 'IN_PROGRESS',
    },
    {
        label: 'Done',
        value: 'DONE',
    },
    {
        label: 'Status Changed',
        value: 'INTERIM_CHANGED',
        icon: 'edited_status',
    },
];
